function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  if (elementToFocus) {
    elementToFocus.focus();
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.focus();
}

class ShareUtil {
  static generatePrefix () {
    // select the checked input of the model 
    const modelNode = document.querySelector('.variant-option-model input:checked');
    const modelInputs = document.querySelectorAll('.variant-option-model input');
  
    let colorSelectPrefix = '';
    let modelIndex  = 0;
    if (modelNode && modelInputs.length > 0) {
      modelIndex = modelNode.getAttribute('data-index');
      if (modelInputs.length > 2) {
        if (modelIndex === '1' || modelIndex === 1) {
          colorSelectPrefix = '2024_';
        } else if (modelIndex === '2' || modelIndex === 2) {
          colorSelectPrefix = 'chain_';
        }
      } else {
        if (modelIndex === '1' || modelIndex === 1 )colorSelectPrefix = 'chain_';
      }
    }
    return colorSelectPrefix;
  }
  
  static isMobile() {
    var userAgentInfo = navigator.userAgent;
    var mobileAgents = [ "Android", "iPhone", "SymbianOS", "Windows Phone", "iPad","iPod"];
    var mobile_flag = false;
    for (var v = 0; v < mobileAgents.length; v++) {
        if (userAgentInfo.indexOf(mobileAgents[v]) > 0) {
            mobile_flag = true;
            break;
        }
    }
    var screen_width = window.screen.width;
    var screen_height = window.screen.height;
    if(screen_width < 750 && screen_height < 900){
        mobile_flag = true;
    }
    return mobile_flag;
  }
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      if (this.input.value > previousValue) {
        quantityInputData.plus();
      } else {
        quantityInputData.minus();
      }
      this.input.dispatchEvent(this.changeEvent);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalDialogForm extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    this.style.opacity = "1";
    this.style.visibility = "visible";
    this.style.zIndex = "101";
    this.style.display = "block";

    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    this.style.opacity = "0";
    this.style.visibility = "hidden";
    this.style.zIndex = "-1";
    this.style.display = "none";

    removeTrapFocus(this.openedBy);
  }
}
customElements.define("modal-dialog-form", ModalDialogForm);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      ).focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("ul");
    this.sliderItems = this.querySelectorAll("li");
    this.pageCount = this.querySelector(".slider-counter--current");
    this.pageTotal = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.productSlider = this.querySelector(".product-slider-box");
    
    this.initThumbnail();

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / sliderItemsToShow[0].clientWidth
    );
    if (this.productSlider) {
      this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 4;
    } else {
      this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    }
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    if (this.productSlider) {
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 4;
    } else {
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;
    }

    if (this.currentPage === 1) {
      this.prevButton.setAttribute("disabled", true);
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute("disabled", true);
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + this.sliderLastItem.clientWidth
        : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
  
  initThumbnail () {
    $('[thumbnail-color]').hide();
    const colorSelectPrefix = ShareUtil.generatePrefix();
    let Upcolor = `${colorSelectPrefix}${document.getElementById('color_label').innerHTML.toLowerCase().replace(/(^\s*)|(\s*$)/g, "" ).replace(" ","_")}`;
    
    const color_attribute = '[thumbnail-color="' + Upcolor + '"]';
    const FirstsThumbnail = $(color_attribute).first();
    $(color_attribute).show();
    FirstsThumbnail.click();
    
    const U_color = document.getElementById('color_label');
    
    window.globalData = {
      currentProductThumbsIndex: 0
    }
    
    $("#color_fieldset input").each(function(){
      $(this).click(function(e){
        var name = $(this).attr('value');
        U_color.innerHTML = name;
        window.globalData['currentProductThumbsIndex'] = 0;
      });
    });
    
    $('slider-component').on('click', 'li.slide-image-handler', (event) => {
      const target = event.currentTarget;
      this.onThumbnailClick(target);
    });
  }
  
  onThumbnailClick (x) {
    let clickedImageMediaId = x.dataset.mediaId;
    const newImage = document.querySelector(`.product__media-item-handler[data-media-id="${clickedImageMediaId}"]`);
    const parentData = newImage.parentElement;

    parentData.prepend(newImage);
    newImage.style.display = "block";

    document.querySelectorAll('.slide-image-handler').forEach(thumb => thumb.classList.remove('active-thumb'));
    document.querySelector(`.slide-image-handler[data-media-id="${clickedImageMediaId}"]`).classList.add('active-thumb');
    updateIndex(clickedImageMediaId);
  }
}

customElements.define("slider-component", SliderComponent);

class SliderComponentAccessory extends SliderComponent {
  
  constructor() {
    super();
  }
  
  initThumbnail () {
    document.querySelector("li:nth-child(1) > img").classList.add('active-thumb');
    
    $('slider-component-accessory').on('click', 'li.slider__slide', (event) => {
      const target = event.currentTarget;
      this.onThumbnailClick(target);
    });
  }
  
  onThumbnailClick (x) {
    let clickedImage = x.dataset.mediaId;
    const newImage = document.querySelector(`[data-media-id="${clickedImage}"]`);
    const parentData = newImage.parentElement;

    parentData.prepend(newImage);
    newImage.style.display = "block";
  
    document.querySelectorAll('.slide-image').forEach(thumb => thumb. classList.remove('active-thumb'));
    document.querySelector(`[data-media-id="${clickedImage}"] > img`).classList.add('active-thumb');
  };
}

customElements.define("slider-component-accessory", SliderComponentAccessory);


class VariantSelects extends HTMLElement {
  constructor() {
    super();
    // the variant data init
    this.getVariantData();
    // bind the change event of variant input
    this.addEventListener("change", this.onVariantChange);
  }

  before() {}

  after() {}

  onVariantChange(e) {
    this.before(e);
    this.updateOptions(e);
    this.renderVariantOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.filterMedia();
      // this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }

    this.after();
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.variantData.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader =
      this.stickyHeader || document.querySelector("sticky-header");
    if (this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
    }
    // window.setTimeout(() => { parent.querySelector('li.product__media-item').scrollIntoView({behavior: "smooth"}); });
  }

  filterMedia() {
    $("[thumbnail-color]").hide();

    var selected_variant = this.currentVariant.featured_media.alt;

    var selected_attribute = '[thumbnail-color="' + selected_variant + '"]';

    var FirstThumbnail = $(selected_attribute).first();

    if (selected_variant == selected_variant) {
      FirstThumbnail.click();
      $(selected_attribute).show();
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderPrice(html) {
    const id = `price-${this.dataset.section}`;
    const destination = document.querySelectorAll(".product-price-handler");
    const source = html.getElementById(id);

    if (source && destination.length > 0) {
      for (let i = 0; i < destination.length; i++) {
        destination[i].innerHTML = source.innerHTML;
      }
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        this.renderPrice(html);

        const price = document.getElementById(`price-${this.dataset.section}`);
        const metafields = document.getElementById(
          `metafields-${this.dataset.section}`
        );
        const delivery = document.getElementById(
          `delivery-${this.dataset.section}`
        );
        const coupons = document.getElementById(
          `coupons-${this.dataset.section}`
        );
        const coupons_eu = document.getElementById(
          `coupons_eu-${this.dataset.section}`
        );

        if (price) price.classList.remove("visibility-hidden");
        if (metafields)
          metafields.classList.remove("visibility-hidden"),
            this.updateMetafields(html);
        if (delivery)
          delivery.classList.remove("visibility-hidden"),
            this.updateDelivery(html);
        if (coupons)
          coupons.classList.remove("visibility-hidden"),
            this.updateCoupons(html);
        if (coupons_eu)
          coupons_eu.classList.remove("visibility-hidden"),
            this.updateCouponsEu(html);
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );

        this.renderSaleItem(html);
      });
  }

  renderVariantOptions() {}

  renderSaleItem(html) {
    const productSaleTabsContainer = document.querySelector(
      ".extra-acc-container"
    );
    const sourceTabs = html.querySelectorAll("product-sale-tab");

    const saleTabList =
      productSaleTabsContainer.querySelectorAll("product-sale-tab");
    saleTabList.forEach((child) => {
      child.remove();
      child.removeHandle();
    });

    for (let i = 0; i < sourceTabs.length; i++) {
      productSaleTabsContainer.appendChild(sourceTabs[i]);
    }
  }

  updateMetafields(html) {
    const id = `metafields-${this.dataset.section}`;
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
  }

  updateDelivery(html) {
    const id = `delivery-${this.dataset.section}`;
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
  }

  updateCoupons(html) {
    const id = `coupons-${this.dataset.section}`;
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
  }

  updateCouponsEu(html) {
    const id = `coupons_eu-${this.dataset.section}`;
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", true);
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const metafields = document.getElementById(
      `metafields-${this.dataset.section}`
    );
    const delivery = document.getElementById(
      `delivery-${this.dataset.section}`
    );
    const coupons = document.getElementById(`coupons-${this.dataset.section}`);
    const coupons_eu = document.getElementById(
      `coupons_eu-${this.dataset.section}`
    );
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (metafields) metafields.classList.add("visibility-hidden");
    if (delivery) delivery.classList.add("visibility-hidden");
    if (coupons) coupons.classList.add("visibility-hidden");
    if (coupons_eu) coupons_eu.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector(".product-variants-list").textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class VariantRadiosEnhance extends VariantSelects {
  constructor() {
    super();
    this.initOptionListObject();
    this.updateOptions();
    this.renderVariantOptions();
    this.validateExistVariantOption();
  }

  initOptionListObject() {
    const variantData = JSON.parse(
      this.querySelector("#product-variants-info").textContent
    );

    const optionsListObject = {};
    const optionList = [];

    for (let i = 0; i < variantData.length; i++) {
      const { options, available, inventory_quantity } = variantData[i];
      optionsListObject[options.join("/").trim()] = {
        available,
        inventory_quantity: inventory_quantity,
        len: options.length,
      };
      optionList.push(options);
    }

    this.optionsListObject = optionsListObject;
    this.optionList = optionList;
  }

  // Needing to verify that the options selected are present.
  updateOptions(e) {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));

    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });

    if (e) {
      const optionsKey = this.options.join("/").trim();
      // if the selected option was not present, you needed to update the option
      if (!this.optionsListObject[optionsKey]) {
        // Record the option you selected at this moment.
        const target = e.target;
        const val = target.value;
        const option = this.findFirstExsitVariant(val);
        if (option) {
          this.options = option.split("/");
        }
      }
    }
  }

  // Base the current selected option, find the frist variant at the option list
  findFirstExsitVariant(val) {
    const ret = null;

    const keys = Object.keys(this.optionsListObject);

    for (let i = 0; i < keys.length; i++) {
      const option = keys[i];
      if (option.includes(val)) {
        return option;
      }
    }

    return ret;
  }

  // Based on the selected option, update the list of variant options.
  renderVariantOptions() {
    this.renderVariantOptionList();
    this.renderSelectOption();
  }

  // When the user has selected an option, and this causes another previously selected option at a diffrence level to be hidden,
  // we should set the first option that was not hidden to the selected state.
  renderSelectOption() {
    // need to select option by postion
    const radiosWrappers = document.querySelectorAll(
      "variant-radios-enhance .variant-option-wrapper"
    );
    radiosWrappers.forEach((wrapper) => {
      const radiosItems = wrapper.querySelectorAll(
        '.variant-option-item:not(.unavailable) input[type="radio"]'
      );
      const options = this.options;

      for (let i = 0; i < radiosItems.length; i++) {
        if (options.includes(radiosItems[i].value)) {
          radiosItems[i].checked = true;
          $(radiosItems[i]).trigger("change");
        }
      }
    });

    this.updateOptions();
    this.updateUpColor();
  }

  updateUpColor() {
    var U_color = document.getElementById("color_label");
    const modelNode = document.querySelector("#color_fieldset input:checked");
    U_color.innerHTML = $(modelNode).attr("value");
  }

  /**
   * Remove options that don't have any variants.
   */
  validateExistVariantOption() {
    const optionList = this.optionList;
    const radiosTitemList = document.querySelectorAll(
      `variant-radios-enhance .variant-option-wrapper:not([data-lock]) .variant-option-item`
    );
    radiosTitemList.forEach((element) => {
      const value = element.getAttribute("data-value");
      const pos = element.getAttribute("data-pos");
      let flag = false;
      for (let i = 0; i < optionList.length; i++) {
        if (optionList[i][+pos - 1].includes(value)) {
          flag = true;
        }
      }

      if (!flag) {
        element.classList.add("hidden");
      } else {
        element.classList.remove("hidden");
      }
    });
  }

  renderVariantOptionList() {
    const options = this.options;
    const optionList = this.optionList;

    // core logic:
    // Since only one option can be selected at a time, the options that can be selected at each level are controlled by other additional attributes.
    // Then you only need to remove the currently selected options on each layer, and then use other options to get the options that can be selected on the current layer.
    // Then cycle through each layer.
    if (this.options) {
      let optionFilterMap = {};
      for (let i = 0; i < options.length; i++) {
        let condition = [];
        for (let t = 0; t < options.length; t++) {
          if (t !== i) {
            condition.push(options[t]);
          }
        }

        let tempRes = [];
        for (let k = 0; k < optionList.length; k++) {
          let elements = optionList.filter((item) =>
            condition.every((element) => item.includes(element))
          );
          for (let j = 0; j < elements.length; j++) {
            if (!tempRes.includes(elements[j][i])) {
              tempRes.push(elements[j][i]);
            }
          }
        }
        optionFilterMap[i] = tempRes;
      }

      Object.keys(optionFilterMap).forEach((key) => {
        const radiosWrapper = document.querySelector(
          `variant-radios-enhance .variant-option-wrapper[data-pos="${
            +key + 1
          }"]`
        );
        const existVariants = optionFilterMap[key];
        const radios = radiosWrapper.querySelectorAll('input[type="radio"]');

        for (let i = 0; i < radios.length; i++) {
          const radio = radios[i];
          if (existVariants.includes(radio.value)) {
            radio.parentNode.classList.remove("unavailable");
          } else {
            radio.parentNode.classList.add("unavailable");
          }
        }
      });
    }
  }

  filterAndRemoveOptions(variants, options) {
    return variants
      .filter((variant) => {
        return options.every((option) => variant.includes(option));
      })
      .map((variant) => {
        return variant.filter((option) => !options.includes(option));
      })
      .flat();
  }

  removeKeyFromArray(arr, key) {
    return arr.filter((item) => item !== key);
  }

  getCheckedOptionValue(pos) {
    const radiosWrapper = document.querySelectorAll(
      `variant-radios-enhance .variant-option-wrapper:not([data-lock]) .variant-option-item:not([data-pos="${pos}"])`
    );
    const values = [];
    radiosWrapper.forEach((radioWrapper) => {
      const radio = radioWrapper.querySelector('input[type="radio"]');
      if (radio.checked) {
        values.push(radio.value);
      }
    });

    return values;
  }
}

customElements.define("variant-radios-enhance", VariantRadiosEnhance);

class CollectionsVariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.init();
  }

  init() {
    this.updateOptions();
    this.updateMasterId();

    const current = this.currentVariant;

    const mediaWrapper = this.closest(".grid__item_collection");
    const priceNodes = $(mediaWrapper).find(".price-wrapper");
    priceNodes.removeClass("price-wrapper-active");
    var matchingNodes = priceNodes.filter(function () {
      var variantTitle = $(this).data("variant-title");
      // 检查 variant-title 是否包含指定的字符串
      return variantTitle && variantTitle.indexOf(current.title) !== -1;
    });

    $(matchingNodes).addClass("price-wrapper-active");
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.renderProductInfo();
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }

  updateMasterId() {
    const variantData = this.getVariantData();
    this.currentVariant = variantData.find((variant) => {
      return variant.options
        .map((option) => {
          return this.options[0] === option;
        })
        .includes(true);
    });
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    this.updateMedia();
  }

  updateMedia() {
    const mediaWrapper = this.closest(".card-product-media-wrapper");
    const current = this.currentVariant;
    const productMediaImagesList =
      window[`PRODUCT_MEDIAS_${current.featured_image.product_id}`];
    const currentOption = current.featured_media.alt;

    const productMediaImagesListFilter =
      productMediaImagesList && productMediaImagesList.length
        ? productMediaImagesList.filter((element) => {
            return element.alt === currentOption;
          })
        : [];

    // modify link string
    const mediaImages = mediaWrapper.querySelectorAll(".card-product-image");
    // set src to image
    for (let i = 0; i < mediaImages.length; i++) {
      const mediaImage = mediaImages[i];
      mediaImage.setAttribute("src", productMediaImagesListFilter[i]["src"]);
      mediaImage.setAttribute(
        "srcset",
        productMediaImagesListFilter[i]["srcset"]
      );
      mediaImage.setAttribute("alt", productMediaImagesListFilter[i]["alt"]);
      mediaImage.setAttribute(
        "width",
        productMediaImagesListFilter[i]["width"]
      );
      mediaImage.setAttribute(
        "height",
        productMediaImagesListFilter[i]["height"]
      );
      mediaImage.setAttribute(
        "sizes",
        productMediaImagesListFilter[i]["sizes"]
      );
    }

    this.renderPriceContent(current.title);
  }

  renderPriceContent(title) {
    const mediaWrapper = this.closest(".grid__item_collection");
    const priceNodes = $(mediaWrapper).find(".price-wrapper");
    priceNodes.removeClass("price-wrapper-active");
    var matchingNodes = priceNodes.filter(function () {
      var variantTitle = $(this).data("variant-title");
      // 检查 variant-title 是否包含指定的字符串
      return variantTitle && variantTitle === title;
    });

    $(matchingNodes).addClass("price-wrapper-active");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("collections-variant-radios", CollectionsVariantRadios);

// nav
$(".header__inline-menu li").each(function () {
  $(this).click(function () {
    var $Is = $("#shopify-section-header").hasClass(
      "shopify-section-header-sticky"
    );
    if ($Is) {
    } else {
      $(this)
        .parents("#shopify-section-header")
        .toggleClass("shopify-section-header-hidden", "animate");
    }
    $("#shopify-section-header").addClass(
      "shopify-section-header-hidden",
      "animate"
    );
  });
});

$(window).scroll(function () {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  if (scrollTop < 60) {
    $(".header__inline-menu li")
      .find(".second_nav")
      .removeClass("active", "animate");
  }
});

function updateIndex(targetId) {
  const colorSelectPrefix = ShareUtil.generatePrefix();
  let Upcolor = `${colorSelectPrefix}${document
    .getElementById("color_label")
    .innerHTML.toLowerCase()
    .replace(/(^\s*)|(\s*$)/g, "")
    .replace(" ", "_")}`;

  const color_attribute = '[thumbnail-color="' + Upcolor + '"]';
  const thumbNodeList = $(color_attribute);

  for (let index = 0; index < thumbNodeList.length; index++) {
    if (thumbNodeList[index].dataset.mediaId === targetId) {
      window.globalData["currentProductThumbsIndex"] = index;
    }
  }
}
class InsuranceSelectTab extends HTMLElement {
  constructor() {
    super();
    this.delegateChange();
  }

  delegateChange() {
    $(".insurance-block-main").on("click", function (event) {
      if (event.target.tagName.toUpperCase() === "A") {
        return;
      }
      if ($(this).hasClass("selected")) {
        $(this).removeClass("selected");
        $("#insurance_laka_input").val("none");
        this.dispatchEvent(new Event("insurance-cancled"));
      } else {
        $(this).addClass("selected");
        $("#insurance_laka_input").val("laka");
        this.dispatchEvent(new Event("insurance-selected"));
      }
    });
  }
}

customElements.define("insurance-select-tab", InsuranceSelectTab);

class CartInsuranceItem extends HTMLElement {
  constructor() {
    super();
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    this.delegateChange();
  }

  enableLoading() {
    const cartDrawerItemElements = document.querySelector(
      `#cart-insurance-container-${this.deleteIndex} .loading-overlay`
    );
    [cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );
  }

  disableLoading() {
    const cartDrawerItemElements = document.querySelector(
      `#cart-insurance-container-${this.deleteIndex} .loading-overlay`
    );
    [cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }

  deleteHandler() {
    this.enableLoading();
    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];

    const formData = new FormData();
    if (this.cart) {
      formData.append(
        "sections",
        this.cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append("sections_url", window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }

    formData.append("properties[_insurance_option]", "none");
    formData.append("line", this.deleteIndex);
    formData.append("quantity", this.quantity);

    config.body = formData;

    fetch(`/cart/change.js`, config)
      .then((response) => response.json())
      .then((response) => {
        this.disableLoading();
        this.cart.renderContents(response);
        return response;
      })
      .catch((e) => {
        console.error(e);
      });
  }

  delegateChange() {
    const deleteNode = this.querySelector(".cart-item-delete-insurance");
    this.deleteIndex = $(deleteNode).data("index");
    this.quantity = $(deleteNode).data("quantity");
    deleteNode.addEventListener("click", this.deleteHandler.bind(this));
  }
}

customElements.define("cart-insurance-item", CartInsuranceItem);

let customAddCartItem = [];
let defaultItems = [];

class ProductSale extends HTMLElement {
  constructor() {
    super();
    this.reset();
    this.hideAssociateVariantsList =
      ($(this).data("hide-associate-vaiants") || "") + "";
    this.variantId = $(this).data("variant-id") + "";
  }

  reset() {
    const itemsString = $(this).data("variant-list") + "";

    if (typeof itemsString === "undefined") {
      return;
    }

    const itemsArr = itemsString.split(",");

    // Use a Set for faster lookups
    const itemsSet = new Set(itemsArr);

    // Iterate backwards to avoid index issues when splicing
    for (let i = customAddCartItem.length - 1; i >= 0; i--) {
      const { id } = customAddCartItem[i];
      if (itemsSet.has(id)) {
        customAddCartItem.splice(i, 1);
      }
    }
  }
}

class ProductSaleTab extends ProductSale {
  constructor() {
    super();
    this.init();
    this.event();
  }

  addAccByDefault() {
    this.items = $(this).data("variant-list") + "";
    if (typeof this.items === "undefined") {
      return;
    }
    this.default_selected = $(this).data("deafult-selected");
    this.itemsArr = this.items.split(",");

    // selected by default
    if (this.default_selected) {
      customAddCartItem = customAddCartItem.concat(
        this.itemsArr.map(function (id) {
          return {
            id,
            quantity: 1,
          };
        })
      );
    }
  }

  init() {
    let associateColor = $(this).data("associate-color");
    // if the associateColor is exist
    if (associateColor) {
      const possibleNames = [
        "Color",
        "Kleur",
        "color",
        "Colour",
        "Couleur",
        "colore",
        "Colore",
        "Farbe",
        "farbe",
        "색",
        "色",
        "färg",
        "farve",
      ];
      const checkedNode = Array.from(
        document.querySelectorAll('input[type="radio"]')
      ).find((input) => possibleNames.includes(input.name) && input.checked);
      // const checkedNode = document.querySelector('input[name="Color"]:checked');
      let checkedColor = "";
      if (checkedNode) {
        checkedColor = checkedNode.value;
      }
      if (checkedColor === associateColor) {
        this.addAccByDefault();
      } else {
        this.querySelector(".pannel_content").classList.remove("selected");
      }
    } else {
      this.addAccByDefault();
    }

    if (
      !this.hideAssociateVariantsList ||
      this.hideAssociateVariantsList.trim() === ""
    ) {
      return;
    }

    if (
      this.hideAssociateVariantsList &&
      this.hideAssociateVariantsList !== "" &&
      this.hideAssociateVariantsList.split(",").includes(this.variantId)
    ) {
      if ($(this).data("hide-type") === 0) {
        this.remove();
        this.removeHandle();
      } else {
        this.querySelector(".pannel_content-operate").remove();
        this.querySelector(".pannel_content").classList.remove("user-select");
      }
    }
  }

  event() {
    this.addEventListener("click", () => {
      if (!$(this).data("readonly") && !$(this).attr("disabled")) {
        if (
          this.hideAssociateVariantsList &&
          this.hideAssociateVariantsList !== "" &&
          this.hideAssociateVariantsList.split(",").includes(this.variantId)
        ) {
          return;
        }
        const container = this.querySelector(".pannel_content-sale-item");
        if (container.classList.contains("selected")) {
          this.querySelector(".pannel_content-sale-item").classList.remove(
            "selected"
          );
          for (let i = 0; i < customAddCartItem.length; i++) {
            for (let k = 0; k < this.itemsArr.length; k++) {
              if (customAddCartItem[i]["id"] === this.itemsArr[k]) {
                customAddCartItem.splice(i, 1);
                i--;
              }
            }
          }
        } else {
          this.querySelector(".pannel_content-sale-item").classList.add(
            "selected"
          );
          customAddCartItem = customAddCartItem.concat(
            this.itemsArr.map(function (id) {
              return {
                id,
                quantity: 1,
              };
            })
          );
        }
      }
    });
  }

  removeHandle() {
    for (let i = 0; i < customAddCartItem.length; i++) {
      for (let k = 0; k < this.itemsArr.length; k++) {
        if (customAddCartItem[i]["id"] === this.itemsArr[k]) {
          customAddCartItem.splice(i, 1);
          i--;
        }
      }
    }
  }
}

customElements.define("product-sale-tab", ProductSaleTab);

class AddExtraAccToCartFn extends HTMLElement {
  constructor() {
    super();
    this._init();
  }

  _init() {
    window.addExtraAccToCartFn =
      window.addExtraAccToCartFn ||
      function addExtraAccToCartFn(cart) {
        const accItems = customAddCartItem.concat(defaultItems);
        if (accItems.length) {
          let formCgo = {
            sections: cart.getSectionsToRender().map((section) => section.id),
            items: accItems,
          };

          return fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formCgo),
          });
        }
        return null;
      };
  }
}

class ProductAccessories extends AddExtraAccToCartFn {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.items = $(this).data("default-acc-list") + "";
    if (typeof this.items === "undefined") {
      return;
    }

    const itemsArr = this.items.split(",");

    itemsArr.forEach((id) => {
      defaultItems.push({
        id,
        quantity: 1,
      });
    });
  }
}

customElements.define("product-deafult-accessories", ProductAccessories);

class AddExtraAccToCartComponent extends AddExtraAccToCartFn {
  constructor() {
    super();
  }
}

customElements.define(
  "add-extra-acc-to-cart-component",
  AddExtraAccToCartComponent
);

class IframeLink extends HTMLElement {
  constructor() {
    super();
    this.init();
    this.event();
  }

  init() {
    const buttonNode = this.querySelector("#open-iframe-button");
    const link = buttonNode.getAttribute("data-link");

    const templateWrapper = document.createElement("div");
    templateWrapper.classList = "iframe-wrapper";
    templateWrapper.innerHTML = `
      <div class="iframe-mask"></div>
      <div class="iframe-modal">
        <div class="iframe-model-close">X</div>
        <iframe id="open-iframe-button-modal" src="${link}" width="1" height="1" style="height: 100%;width: 100%;"></iframe>
      </div>
    `;

    document.body.appendChild(templateWrapper);
  }

  event() {
    this.querySelector("#open-iframe-button").addEventListener(
      "click",
      function () {
        const framdWrapperNode = document.querySelector(`.iframe-wrapper`);
        framdWrapperNode.style.background = "transparent";
        framdWrapperNode.style.position = "fixed";
        framdWrapperNode.style.top = "0";
        framdWrapperNode.style.zIndex = "999";
        framdWrapperNode.style.width = "100%";
        framdWrapperNode.style.height = "100%";

        document.body.classList.add("overflow-modal-hidden");
      }
    );

    document
      .querySelector(".iframe-model-close")
      .addEventListener("click", () => {
        const framdWrapperNode = document.querySelector(`.iframe-wrapper`);
        document.body.removeChild(framdWrapperNode);
        document.body.classList.remove("overflow-modal-hidden");
        this.init();
        this.event();
      });

    document.querySelector(".iframe-mask").addEventListener("click", () => {
      const framdWrapperNode = document.querySelector(`.iframe-wrapper`);
      document.body.removeChild(framdWrapperNode);
      document.body.classList.remove("overflow-modal-hidden");
      this.init();
      this.event();
    });
  }
}

customElements.define("iframe-link", IframeLink);

// To support selection of different variants of product
class MultipleVariantAcc extends HTMLElement {
  constructor() {
    super();
    this.init();
    this.event();
  }

  init() {
    this.allVariantIds = this.getAttribute("data-variant-list");
  }

  addItemToCustomCartData(id) {
    customAddCartItem = customAddCartItem.filter(
      (item) => !(this.allVariantIds.includes(item.id) && item.id !== id)
    );
    customAddCartItem = customAddCartItem.concat({
      id,
      quantity: 1,
    });
  }

  remvoeItemFromCustomCartData(id) {
    customAddCartItem = customAddCartItem.filter((item) => item.id !== id);
  }

  event() {
    this.querySelectorAll(".variant-type").forEach((element) => {
      element.addEventListener("click", () => {
        $(".variant-type").removeClass("selected");
        const node = element.querySelector("input");
        if (node.checked === true) {
          element.querySelector("input").checked = false;
          this.remvoeItemFromCustomCartData(node.value);
        } else {
          element.querySelector("input").checked = true;
          this.addItemToCustomCartData(node.value);
          element.classList.add("selected");
        }
      });
    });
  }
}

customElements.define("multiple-variant-acc", MultipleVariantAcc);

class TwyLocalization extends HTMLElement {
  constructor() {
    super();
    this.observe();
    this.event();
  }

  hide() {
    document
      .querySelectorAll(".tenways_top localization-form")
      .forEach((element) => {
        element.querySelector(".disclosure__list").setAttribute("hidden", true);
        element.elements.button.classList.remove("active-current");
      });
  }

  event() {
    let startX, startY;
    document.addEventListener("touchstart", (event) => {
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    });

    document.addEventListener("touchend", (event) => {
      const rawDeltaY = event.changedTouches[0].clientY - startY;
      const deltaX = Math.abs(event.changedTouches[0].clientX - startX);
      const deltaY = Math.abs(event.changedTouches[0].clientY - startY);
      const threshold = 5;
      if (deltaX > threshold || deltaY > threshold) {
        const inDisclosureList = event.target.closest(".tenways_top") === null;
        if (inDisclosureList) {
          $(".header__icons #tenways_top").css("display", "none");
          $(".localization-button").removeClass("up");
          this.hide();
        }
      }
    });
  }

  observe() {
    const target = document.getElementById("tenways-locate-seletor");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            $(".header__icons #tenways_top").css("display", "none");
            $(".localization-button").removeClass("up");
            this.hide();
          }
        });
      },
      {
        root: null,
        threshold: 0,
      }
    );

    observer.observe(target);
  }
}

customElements.define("twy-localization", TwyLocalization);

class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", onKeyUpEscape);
    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this)
    );
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");

    this.detailsContainer.addEventListener(
      "keyup",
      (event) => event.code.toUpperCase() === "ESCAPE" && this.close()
    );
    this.summaryToggle.addEventListener(
      "click",
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      "click",
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute("role", "button");
    this.summaryToggle.setAttribute("aria-expanded", "false");
  }

  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest("details").hasAttribute("open")
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains("modal-overlay")
    )
      this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest("details").setAttribute("open", true);
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("overflow-hidden");

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute("open");
    document.body.removeEventListener("click", this.onBodyClickEvent);
    document.body.classList.remove("overflow-hidden");
  }
}

customElements.define("details-modal", DetailsModal);

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("cart-notification");
    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add("animate", "active");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    this.notification.classList.remove("active");

    document.body.removeEventListener("click", this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: "cart-notification-button",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest("cart-notification")) {
      const disclosure = target.closest("details-disclosure");
      this.activeElement = disclosure
        ? disclosure.querySelector("summary")
        : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);
